import { gql } from "apollo-angular";

export const GET_ECUS_QUERY = gql`query configuratorAllEcuss {
    configuratorAllEcus {
        Id
        Name
        ParentId
        EcuFamily
    }
  }
  `

export const GET_ECUS_WITH_SOFTWARE_VERSIONS_QUERY = gql`query configuratorAllEcusWithSoftwareVersions {
    configuratorAllEcusWithSoftwareVersions {
        Id
        Name
        ParentId
        EcuFamily
        SoftwareVersions
    }
  }
  `